var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.4513 1.90332H21.8248L14.4547 10.3268L23.125 21.7893H16.3362L11.019 14.8374L4.93495 21.7893H1.55943L9.44243 12.7794L1.125 1.90332H8.08611L12.8924 8.25765L18.4513 1.90332ZM17.2673 19.7701H19.1366L7.07039 3.81645H5.06446L17.2673 19.7701Z","fill":"black"}));
}

Twitter.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
